import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Allegato, ModelInvoice } from 'src/app/entities/invoices';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-allegati',
  templateUrl: './allegati.component.html',
  styleUrls: ['./allegati.component.css']
})
export class AllegatiComponent implements OnInit, OnChanges {

  @Input() model : ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();

  public AttachmentsSize : number =0;

  constructor(public toastService: ToastService) { }

  ngOnInit(): void {
    this.model?.FatturaElettronicaBody.Allegati.forEach((allegato)=>{
      this.AttachmentsSize+=new Blob([allegato.Attachment]).size;
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
    }
  }

  public addAllegato(event: any){
    let new_size=0;
    try {
      let file = (event.target.files as FileList)[0];
      if(!this.controlloLimiteAllegati(file.size))
          throw new Error("File size");
        new_size=file.size;
      let allegato : Allegato = {
        NomeAttachment: '',
        AlgoritmoCompressione :'',
        FormatoAttachment:'',
        DescrizioneAttachment:'',
        Attachment: ''      
        
      }
      // console.log(file);
      allegato.NomeAttachment = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        allegato.Attachment = (reader.result)?.toString().split(',')[1] as string;
        this.model?.FatturaElettronicaBody.Allegati.push(allegato);
        this.notifyChange();
      };
      event.target.value = null;
    } catch (error) {
      new_size=0;
      this.toastService.openToastWithConfig(false, 0,  "Il file è troppo grande per essere caricato. Il limite complessivo degli allegati non deve superare 5Mb", "error");
      //this.toastConfig = {class:"error", title:await new UTILS().getTranslateTitle(this.translate, 'toast.readFile.error')};
    }
    this.AttachmentsSize+=new_size;
  }

  private controlloLimiteAllegati(new_size : number){
      if( this.AttachmentsSize+new_size > 5000000 )
          return false;
      return true;
  }

  public deleteAllegato(index: number){
    this.AttachmentsSize-=new Blob([this.model!.FatturaElettronicaBody.Allegati[index].Attachment]).size;
    this.model?.FatturaElettronicaBody.Allegati.splice(index, 1);
  }

  public notifyChange(){
    this.modelChange.emit(this.model);
  }
}
